﻿export default class FilterList {
    constructor() {
        Handlebars.registerHelper({
            eq: function (v1, v2) {
                return v1 === v2;
            },
            ne: function (v1, v2) {
                return v1 !== v2;
            },
            lt: function (v1, v2) {
                return v1 < v2;
            },
            gt: function (v1, v2) {
                return v1 > v2;
            },
            lte: function (v1, v2) {
                return v1 <= v2;
            },
            gte: function (v1, v2) {
                return v1 >= v2;
            },
            and: function (v1, v2) {
                return v1 && v2;
            },
            or: function (v1, v2) {
                return v1 || v2;
            }
        });
        this.$container = $(".FilterList");
        this.$filterForm = $(".FilteredList-filterForm");
        this.formMethode = "get";
        this.formAction = "/umbraco/api/VacancyApi/GetVacancies";
        this.$sections = [];
        this.$paging = $(".FilteredList-paging");

        this.queryObject = this.loadQueryStringAsQueryObject();
        this.queryArray = this.mapQueryStringObjectToArray(this.queryObject);

        this.filter(this.queryArray, true);
        this.setEventListeners();

        var source = $("#FilteredList").html();
        this.template = Handlebars.compile(source);
    }

    setEventListeners() {
        $(document)
            .on('click', '.FilteredList-filterSurrogateElement .toggle-check', this.onChange.bind(this))
            .on('change', '.selectStyle select', this.onSelect.bind(this))
            .on('click', '.FilterList-reset .reset', this.onResetClick.bind(this))
            .on("click", '.pagination--doNavigate', this.onPagingNavigate.bind(this))
    }

    //Methods
    loadQueryStringAsQueryObject() {
        var search = location.search.substring(1);
        return search ? JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
            function (key, value) { return key === "" ? value : decodeURIComponent(value); }) : {};
    }

    mapQueryStringObjectToArray(queryObject) {
        var queryArray = [];
        $.each(queryObject, function (key, value) {
            queryArray.push({
                name: key,
                value: value
            });
        });

        return queryArray;
    }

    pushQueryToHistory() {
        var queryString = this.serializeQueryObject(this.buildQueryObjectFromForm());

        history.pushState(null, null, '?' + queryString + window.location.hash);
    }

    serializeQueryObject(obj) {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    buildQueryObjectFromForm(_exclude) {
        var exclude = _exclude || [];

        var queryObject = {};

        $('.FilteredList-requestFilter').each(function (i, elm) {
            var $filter = $(elm);
            queryObject[$filter.attr('name')] = $filter.val();
        });

        var idString = '';
        $('.filterList-filters input[type="checkbox"]:checked').each(function (i, elm) {
            var $checkbox = $(elm);
            if ($checkbox.val() !== null && typeof $checkbox.val() !== "undefined") {
                idString += $checkbox.val() + ',';
            }
        });

        $('.filterList-filters select').each(function (i, select) {
            var $select = $(select);
            $.each($select.find('option'), function (i, option) {
                var $option = $(option);
                if ($option.is(':selected') && $option.val() !== "") {
                    idString += $option.val() + ',';
                }
            });
        });

        idString.slice(0, -1); //strip last comma

        queryObject['filterIds'] = idString;

        return queryObject;
    }

    filter(data, _useQueryString) {
        var useQueryString = _useQueryString || false;

        $.ajax({
            url: this.formAction,
            type: this.formMethode,
            data: useQueryString
                ? data
                : this.mapRequestData(data),
            success: this.onFiltered.bind(this)
        });

        //debug:
        //this.onFiltered(json);
    }

    filterFirstTime(data) {
        $.ajax({
            url: this.formAction,
            type: this.formMethode,
            data: data,
            success: this.onFiltered.bind(this)
        });

        //debug:
        //this.onFiltered(json);
    }

    onFiltered(data) {
        this.render(data);
        this.pushQueryToHistory();
    }

    render(data) {
        var html = this.template(this.mapViewData(data));
        this.$container.html(html);
    }

    mapRequestData(data) {
        var newArray = [];
        if (data !== null && typeof data !== "undefined") {
            //load filters ad id string
            var idString = '';
            idString.slice(0, -1); //strip last comma

            //get all checkboxes
            $('.filterList-filters input[type="checkbox"]:checked').each(function (i, elm) {
                var $checkbox = $(elm);
                if ($checkbox.val() !== null && typeof $checkbox.val() !== "undefined")
                    idString += $checkbox.val() + ',';
            });

            //get all selectlists
            $('.filterList-filters select').each(function (i, elm) {
                var $option = $(elm);
                if ($option.val() !== null && typeof $option.val() !== "") {
                    idString += $option.val() + ',';
                }
            });

            idString.slice(0, -1); //strip last comma

            $.each(data, function (i, elm) {
                if (elm.name !== "filterIds") {
                    newArray.push(elm);
                }
            });

            newArray.push({ name: "filterIds", value: idString });
        }

        return newArray;
    }

    mapViewData(data) {
        var pages = [];
        for (var i = 1; i <= data.numberOfPages; i++) {
            pages.push({
                index: i,
                pageNotIsIndex: data.page != i
            });
        }
        var nextPage = (data.page + 1);
        var prevPage = (data.page - 1);
        var showPager = pages.length > 1;

        $(data.filters).each(function (i, elm) {
            if (elm.Value[0] !== null) {
                elm.Filtertype = elm.Value[0].Filtertype;
            }
        });

        var viewData = {
            formAction: this.formAction,
            formMethode: this.formMethode,
            response: data,
            requestData: {
                pageSize: data.pageSize,
                page: data.page
            },
            paging: {
                nextPage: nextPage,
                prevPage: prevPage,
                prevPageHigherOrOne: prevPage >= 1,
                nextPageLowerOrEquel: nextPage <= data.numberOfPages,
                allPages: pages,
                showPager: showPager
            },
            textfields: {
                filterlijstText: this.$container.data("filterlijsttext"),
                filteroptionText: this.$container.data("filteroptiontext"),
                resetBtnText: this.$container.data("resetbtntext"),
                pagingFirstText: this.$container.data("pagingfirsttext"),
                pagingPrevText: this.$container.data("pagingprevtext"),
                pagingNextText: this.$container.data("pagingnexttext"),
                pagingLastText: this.$container.data("paginglasttext")
            }
        };

        return viewData;
    }

    //Event handlers

    onPagingNavigate(event) {
        event.preventDefault();
        var $target = $(event.target).closest('.pagination--doNavigate');
        var val = $target.data("fieldvalue");
        var input = $target.data("field");
        $("input[name=" + input + "]").val(val).attr('value', val);
        this.filter($target.closest('form').serializeArray());
    }

    onSelect(event) {
        event.preventDefault();
        var $target = $(event.target).closest('.selectStyle');
        var $selectlist = $target.find('> select');
        var $selectedOption = $selectlist.find("option[value=" + $selectlist.val() + "]");
        $selectedOption.attr("selected", "selected");
        this.filterPagerReset();
        this.filter($target.closest('form').serializeArray());
    }

    onChange(event) {
        event.preventDefault();
        var $target = $(event.target).closest('.FilteredList-filterSurrogateElement');
        var $checkbox = $target.find('> input[type="checkbox"]');

        if ($checkbox.is(':checked')) {
            $checkbox.attr('checked', false);
        }
        else {
            $checkbox.attr('checked', true);
        }
        this.filterPagerReset();
        this.filter($target.closest('form').serializeArray());
    }

    //reset paging to 1
    filterPagerReset() {
        $("input[name=page]").val(1).attr('value', 1);
    }

    //reset all fiters
    onResetClick(event) {
        event.preventDefault();
        window.location.href = window.location.pathname;
    }

    //global functions
    isUndefined(obj) {
        return (typeof obj === "undefined");
    }

    isDefined(obj) {
        return (!this.isUndefined(obj));
    }
    hasValue(obj) {
        return (
            obj != null &&
            this.isDefined(obj) &&
            obj !== ""
        );
    }

}
